import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import { obtenerNoticias, agregarNoticia, actualizarNoticia, eliminarNoticia, archivarNoticia, restaurarNoticia } from '../AccionesBackend';
import FormularioNoticia from './FormularioNoticia';
import Swal from "sweetalert2";

const AdminNews = () => {
  const [noticias, setNoticias] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [noticiaSeleccionada, setNoticiaSeleccionada] = useState(null);
  const [error, setError] = useState(null);

  

  const refrescarNoticias = async () => {
    try {
      const response = await obtenerNoticias();
      if (response && response.status === "OK") {
        setNoticias(response.noticias);
        setError(null);
      } else {
        setError("No se encontraron noticias.");
      }
    } catch (err) {
      console.error("Error al obtener noticias:", err);
      setError("Error al obtener noticias.");
    }
  };

  useEffect(() => {
    refrescarNoticias();
  }, []);

  const handleAgregarNuevaNoticia = () => {
    setNoticiaSeleccionada(null); // Para que el formulario esté vacío
    setModalShow(true);
  };

  const handleEditarNoticia = (noticia) => {
    console.log("Noticia seleccionada para edición:", noticia);
    setNoticiaSeleccionada(noticia);
    setModalShow(true);
};

const handleEliminarNoticia = async (id) => {
  if (!id || isNaN(id)) {
      console.error("ID inválido:", id);
      Swal.fire({icon: "error", title: "Error", text: "Error: ID de noticia no válido."});
      return;
      // alert("Error: ID de noticia no válido.");
      // return;
  }

  const confirmacion = window.confirm("¿Estás seguro de que deseas eliminar esta noticia?");
  if (!confirmacion) return;

  try {
      console.log("Eliminando noticia con ID:", id);
      const response = await eliminarNoticia(id);
      if (response && response.status === "OK") {
         Swal.fire({icon: "success", title: "Eliminado", text: "Se Elimino la Noticia",timer: 2000, showConfirmButton: false,
                    }).then(() => {
                        refrescarNoticias();
                    });
          //alert("Noticia eliminada correctamente.");
      } else {
         Swal.fire({icon: "error", title: "Error", text: "Error al eliminar el archivo"});
          return;
          // alert("Error al eliminar la noticia.");
      }
  } catch (error) {
      console.error("Error al eliminar la noticia:", error);
      alert("Error al eliminar la noticia.");
  }
};

const handleArchivarNoticia = async (noticia) => {
  const esActiva = parseInt(noticia.activo) === 1;
  const accion = esActiva ? 'archivar' : 'restaurar';
  const textoAccion = esActiva ? 'archivar (ocultar)' : 'restaurar (mostrar)';

  const confirmacion = await Swal.fire({
    icon: 'question',
    title: `¿Deseas ${textoAccion} esta noticia?`,
    text: esActiva
      ? 'La noticia se ocultará pero no se eliminará. Podrás restaurarla después.'
      : 'La noticia volverá a ser visible para los usuarios.',
    showCancelButton: true,
    confirmButtonText: esActiva ? 'Sí, archivar' : 'Sí, restaurar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: esActiva ? '#f39c12' : '#27ae60',
  });
  if (!confirmacion.isConfirmed) return;

  try {
    const response = esActiva
      ? await archivarNoticia(noticia.id)
      : await restaurarNoticia(noticia.id);

    if (response && response.status === 'OK') {
      Swal.fire({ icon: 'success', title: esActiva ? 'Archivada' : 'Restaurada', text: response.mensaje, timer: 1800, showConfirmButton: false });
      refrescarNoticias();
    } else {
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo completar la acción.' });
    }
  } catch (error) {
    console.error('Error al archivar/restaurar:', error);
    Swal.fire({ icon: 'error', title: 'Error', text: 'Error de conexión.' });
  }
};

const handleGuardarNoticia = async (formData) => {
    console.log("Formulario enviado:", formData);
    console.log("Noticia seleccionada (para edición):", noticiaSeleccionada);

        const usuarioId = localStorage.getItem("rol_id"); // Obtener usuarioId
        const seccionId = 22; // Fijar la sección de noticias


    try {
        let response;
        if (noticiaSeleccionada) {
            console.log("Editando noticia con ID:", noticiaSeleccionada.id);
            response = await actualizarNoticia({
                id: noticiaSeleccionada.id,  // Aseguramos que el ID esté en el nivel correcto
                title: formData.title,
                subtitle: formData.subtitle,
                noticia: formData.noticia,
                motivation: formData.motivation,
                date: formData.date,
                content: formData.content,
                author: formData.author,
                image: formData.image
            });
        } else {
          // Modificamos el bloque POST para enviar FormData
          console.log("Creando nueva noticia...");
          const data = new FormData();
          data.append("title", formData.title || "");
          data.append("subtitle", formData.subtitle || "");
          data.append("noticia", formData.noticia || "");
          data.append("motivation", formData.motivation || "");
          data.append("date", formData.date || "");
          data.append("content", formData.content || "");
          data.append("author", formData.author || "");
          data.append("usuarioId", usuarioId);
          data.append("seccionId", seccionId);
          if (formData.image) {
            data.append("image", formData.image);
          }
          response = await agregarNoticia(data);
        }

        if (response && response.status === "OK") {
          // ✅ Cerrar el modal inmediatamente
          setModalShow(false);
          setNoticiaSeleccionada(null);
          refrescarNoticias();
          Swal.fire({icon: "success", title: "Noticia", text: "Se Publicó la Noticia", timer: 2000, showConfirmButton: false});
        } else {
          Swal.fire({icon: "error", title: "Error", text: "Error al Publicar la Noticia"});
        }
    } catch (error) {
        console.error("Error al guardar la noticia:", error);
        Swal.fire({icon: "error", title: "Error", text: "Error al guardar la noticia."});
    }
};

  return (
    <div>
      <h1>Administrar Noticias</h1>
      <Button variant="success" onClick={handleAgregarNuevaNoticia}>
        Subir Nueva Noticia
      </Button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Título</th>
            <th>Fecha</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {noticias.map(noticia => (
            <tr key={noticia.id} style={{ opacity: parseInt(noticia.activo) === 1 ? 1 : 0.55 }}>
              <td>{noticia.title}</td>
              <td>{new Date(noticia.date).toLocaleDateString('es-MX')}</td>
              <td>
                {parseInt(noticia.activo) === 1
                  ? <Badge bg="success">Activa</Badge>
                  : <Badge bg="secondary">Archivada</Badge>}
              </td>
              <td style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                <Button size="sm" variant="primary" onClick={() => handleEditarNoticia(noticia)}>
                  Editar
                </Button>
                <Button
                  size="sm"
                  variant={parseInt(noticia.activo) === 1 ? 'warning' : 'success'}
                  onClick={() => handleArchivarNoticia(noticia)}
                >
                  {parseInt(noticia.activo) === 1 ? '📂 Archivar' : '♻️ Restaurar'}
                </Button>
                <Button size="sm" variant="danger" onClick={() => handleEliminarNoticia(noticia.id)}>
                  Eliminar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal show={modalShow} onHide={() => setModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{noticiaSeleccionada ? "Editar Noticia" : "Subir Nueva Noticia"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <FormularioNoticia
            noticiaSeleccionada={noticiaSeleccionada}
            onGuardar={handleGuardarNoticia}
            onCancelar={() => setModalShow(false)}
        />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdminNews;
